import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth-guard.guard';
import { ActionGuard } from './guards/action-guard.guard';
import { AuthMulticalculoGuard } from './guards/auth-multicalculo.guard';
import { UserRootGuard } from './guards/user-root.guard';
import { UserPermissoesGuard } from './guards/user-permissoes.guard';
import { OnlyDesktopGuard } from './guards/only-desktop.guard';
import { RequireQueryParamsGuard } from './guards/require-query-params.guard';
import { EmbeddedGuard } from './guards/embedded-guard.guard';
import { EmbeddedOnlyGuard } from './guards/embedded-only.guard';
import { EmbeddedOutsideIframeGuard } from './guards/embedded-outside-iframe.guard';
import { EmbeddedLoginGuard } from './guards/embedded-login.guard';
import { ModulosAdicionaisGuard } from './guards/modulos-adicionais.guard';
import { UserAdminGuard } from './guards/user-admin.guard';
import { MainLayout } from './layouts/main/main-layout.component';
import { RequireQueryParamsSeguradorasGuard } from './guards/require-query-params-seguradoras.guard';
import { CompanyGroupAdminGuard } from './guards/company-group-admin.guard';
import { BloquearFilialGuard } from './guards/bloquear-filial.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'cotacoes'
  },
  {
    path: '',
    children: [
      {
        path: 'cotacao/:idIntegracao/impressao',
        loadComponent: () => import('./pages/cotacao-impressao/cotacao-impressao.component').then(m => m.CotacaoImpressaoComponent),
      }
    ]
  },
  {
    path: '',
    component: MainLayout,
    children: [
      {
        path: 'login',
        loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule),
        canActivate: [EmbeddedLoginGuard]
      },
      {
        path: 'recuperar-senha',
        loadChildren: () => import('./pages/recuperar-senha/recuperar-senha.module').then(m => m.RecuperarSenhaModule)
      },
      {
        path: 'registro-administrador/:chaveCorretora',
        loadChildren: () => import('./pages/registro-admin/registro-admin.module').then(m => m.RegistroAdminModule)
      },
      {
        path: 'redefinir-senha/:chaveRedefinicao',
        loadChildren: () => import('./pages/redefinir-senha/redefinir-senha.module').then(m => m.RedefinirSenhaModule)
      },
      { //para novo usuário
        path: 'criar-senha/:chaveCriacao',
        loadChildren: () => import('./pages/redefinir-senha/redefinir-senha.module').then(m => m.RedefinirSenhaModule)
      },
      {
        path: 'recuperar-senha',
        loadChildren: () => import('./pages/recuperar-senha/recuperar-senha.module').then(m => m.RecuperarSenhaModule)
      },
      {
        path: 'confirmacao',
        loadChildren: () => import('./pages/confirmacao/confirmacao.module').then(m => m.ConfirmacaoModule)
      },
      {
        path: 'politica-de-privacidade',
        loadChildren: () => import('./pages/politica-de-privacidade/politica-de-privacidade.module').then(m => m.PoliticaDePrivacidadeModule)
      },
      {
        path: 'perfil-usuario',
        loadChildren: () => import('./pages/perfil-usuario/perfil-usuario.module').then(m => m.PerfilUsuarioEditarModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'corretoras',
        loadChildren: () => import('./pages/corretoras/corretoras.module').then(m => m.CorretorasModule),
        canActivate: [AuthGuard, ActionGuard]
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthGuard, UserPermissoesGuard]
      },
      {
        path: 'clientes',
        loadChildren: () => import('./pages/clientes/clientes.module').then(m => m.ClientesModule),
        canActivate: [AuthGuard, ActionGuard, UserPermissoesGuard]
      },
      {
        path: 'tarefas',
        loadComponent: () => import('./pages/tarefas/tarefas.component').then(c => c.TarefasComponent),
        canActivate: [AuthGuard, UserPermissoesGuard, ActionGuard,]
      },
      {
        path: 'funil-de-vendas',
        loadChildren: () => import('./pages/negocios/kanban/kanban.module').then(m => m.KanbanModule),
        canActivate: [AuthGuard, ActionGuard, UserPermissoesGuard]
      },
      {
        path: 'lista-negocios',
        loadChildren: () => import('./pages/negocios/lista/lista.module').then(m => m.ListaModule),
        canActivate: [AuthGuard, ActionGuard, UserPermissoesGuard]
      },
      {
        path: "cotacao/:ramo/:page/:idIntegracao",
        loadChildren: () => import("./pages/cotacao/cotacao.module").then(m => m.CotacaoModule),
        canActivate: [AuthGuard, ActionGuard, AuthMulticalculoGuard, UserPermissoesGuard]
      },
      {
        path: 'cotacao/:ramo/:page/:idIntegracao/:versao',
        loadChildren: () => import("./pages/cotacao/cotacao.module").then(m => m.CotacaoModule),
        canActivate: [AuthGuard, ActionGuard, UserPermissoesGuard]
      },
      {
        path: 'cotacao/:ramo/:page/:idIntegracao/:versao/:token',
        loadChildren: () => import("./pages/cotacao/cotacao.module").then(m => m.CotacaoModule),
      },
      {
        path: "cotacao/:ramo/:page",
        loadChildren: () => import("./pages/cotacao/cotacao.module").then(m => m.CotacaoModule),
        canActivate: [AuthGuard, AuthMulticalculoGuard, ActionGuard, UserPermissoesGuard]
      },
      {
        path: 'cotacoes',
        loadChildren: () => import('./pages/cotacoes/cotacoes.module').then(m => m.CotacoesModule),
        canActivate: [AuthGuard, ActionGuard, EmbeddedGuard]
      },
      {
        path: 'pagina-indisponivel',
        loadComponent: () => import('./pages/pagina-indisponivel/pagina-indisponivel.component').then(c => c.PaginaIndisponivelComponent),
      },
      {
        path: 'loading',
        loadComponent: () => import('./pages/loading/loading.component').then(c => c.LoadingComponent),
        canActivate: [EmbeddedOutsideIframeGuard]
      },
      {
        path: 'parcelas-pendentes',
        loadComponent: () => import('./pages/sincronizacoes/parcelas-pendentes/parcelas-pendentes.component').then(c => c.ParcelasPendentesComponent),
        canActivate: [AuthGuard, ActionGuard, UserPermissoesGuard]
      },
      {
        path: 'config-corretora',
        loadChildren: () => import('./pages/corretora/cadastro/cadastro.module').then(m => m.CadastroModule),
        canActivate: [AuthGuard, UserPermissoesGuard]
      },
      {
        path: 'config-usuarios',
        loadChildren: () => import('./pages/corretora/usuarios/usuarios.module').then(m => m.UsuariosModule),
        canActivate: [AuthGuard, ActionGuard, UserPermissoesGuard, BloquearFilialGuard]
      },
      {
        path: 'meu-plano',
        loadChildren: () => import('./pages/configuracoes/meu-plano/meu-plano.module').then(m => m.MeuPlanoModule),
        canActivate: [AuthGuard, UserPermissoesGuard, EmbeddedGuard, BloquearFilialGuard]
      },
      {
        path: 'modulos-adicionais',
        loadComponent: () => import('./pages/configuracoes/modulos-adicionais/modulos-adicionais.component').then(m => m.ModulosAdicionaisComponent),
        canActivate: [AuthGuard, EmbeddedOnlyGuard, UserAdminGuard, ModulosAdicionaisGuard]
      },
      {
        path: 'meu-plano-2',
        loadComponent: () => import('./pages/configuracoes/meu-plano-2/meu-plano.component').then(m => m.MeuPlano2Component),
        canActivate: [AuthGuard, UserPermissoesGuard]
      },
      {
        path: 'config-coberturas',
        loadChildren: () => import('./pages/configuracoes/coberturas/coberturas.module').then(m => m.CoberturasModule),
        canActivate: [AuthGuard, ActionGuard, UserPermissoesGuard]
      },
      {
        path: 'config-ramos',
        loadChildren: () => import('./pages/configuracoes/ramos/ramos.module').then(m => m.RamosModule),
        canActivate: [AuthGuard, ActionGuard, UserPermissoesGuard]
      },
      {
        path: 'config-seguradoras',
        loadChildren: () => import('./pages/configuracoes/seguradoras/seguradoras.module').then(m => m.SeguradorasModule),
        canActivate: [AuthGuard, RequireQueryParamsSeguradorasGuard, ActionGuard, UserPermissoesGuard]
      },
      {
        path: 'config-grupos',
        loadChildren: () => import('./pages/perfil-configuracoes/config-grupos/config-grupos.module').then(m => m.ConfigGruposModule),
        canActivate: [AuthGuard, ActionGuard, UserPermissoesGuard, CompanyGroupAdminGuard]
      },
      {
        path: 'online',
        loadChildren: () => import('./pages/corretor-digital/corretor-digital.module').then(m => m.CorretorDigitalModule),
        canActivate: [AuthGuard, ActionGuard, UserPermissoesGuard]
      },
      {
        path: 'orcamento-cliente',
        loadChildren: () => import('./pages/orcamento-cliente/orcamento-cliente.module').then(m => m.OrcamentoClienteModule),
        canActivate: []
      },
      {
        path: 'painel-notificacoes',
        loadComponent: () => import('./pages/painel-notificacoes/painel-notificacoes.component').then(c => c.PainelNotificacoesComponentPage),
        canActivate: [AuthGuard, UserRootGuard]
      },
      {
        path: 'notificacoes',
        loadChildren: () => import('./pages/notificacoes/notificacoes.module').then(m => m.NotificacoesModule),
        canActivate: [AuthGuard, ActionGuard]
      },
      {
        path: 'apolices',
        loadComponent: () => import('./pages/sincronizacoes/apolices/apolices.component').then(c => c.ApolicesComponent),
        canActivate: [AuthGuard, UserPermissoesGuard]
      },
      {
        path: 'propostas',
        loadComponent: () => import('./pages/sincronizacoes/proposta/proposta.component').then(c => c.PropostaComponent),
        canActivate: [AuthGuard, UserPermissoesGuard]
      },
      {
        path: 'extratos',
        loadComponent: () => import('./pages/sincronizacoes/extrato/extrato.component').then(c => c.ExtratoComponent),
        canActivate: [AuthGuard, UserPermissoesGuard]
      },
      {
        path: 'atendimento-ia',
        loadComponent: () => import('./pages/atendimento-ia/atendimento-ia.component').then(c => c.AtendimentoIaComponent),
        canActivate: [AuthGuard, OnlyDesktopGuard]
      },
      {
        path: 'to-segurado',
        loadComponent: () => import('./pages/to-segurado/to-segurado.component').then(c => c.ToSeguradoComponent),
        canActivate: [AuthGuard, UserPermissoesGuard]
      },
      {
        path: 'config-orcamento',
        loadComponent: () => import('./pages/perfil-configuracoes/configuracoes-orcamento/configuracoes-orcamento.component').then(c => c.ConfiguracoesOrcamento),
        canActivate: [AuthGuard, RequireQueryParamsGuard, UserPermissoesGuard]
      },
    ]
  },
  { path: '**', redirectTo: 'cotacoes' }// error route
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
